export default "__VITE_ASSET__BF9n$R2d__"